import * as defaultImport from "@splunk/react-icons/ArrowSquareRight";
export * from "@splunk/react-icons/ArrowSquareRight";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
